import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import { useAppSelector } from '../../redux/store';
import { PLAYER_INFO_PANEL_LIST_BACKGROUND_COLOR } from '../../styles/colors';
import { PANEL_FRAMELESS_CONTENT_PADDING_STRING } from '../../styles/styles';
import { FramelessPanelSection } from '../framelessPanelSection';
import { PanelHeader } from '../panelHeader';
import { PanelItem } from '../panelItem';
import { PanelContainer } from '../panelStyles';
import { PlayerInfoPanelButtonGroup } from './playerInfoPanelButtonGroup';
import { PlayerInfoPanelContents } from './playerInfoPanelContents';
export const PlayerInfoPanel = () => {
    const playerInfo = useAppSelector((state) => state.playerInfo.playerInfo);
    const loadingUsername = useAppSelector((state) => state.playerInfo.loadingUsername);
    const isFriend = useAppSelector((state) => playerInfo
        ? !!state.contacts.allFriends.find((friendIdName) => friendIdName.id === playerInfo.playerIdName.id)
        : undefined);
    const getHeaderTitle = useCallback(() => {
        if (playerInfo) {
            return playerInfo.playerIdName.name;
        }
        if (loadingUsername) {
            return 'Loading...';
        }
        return 'Player Info';
    }, [loadingUsername, playerInfo]);
    const getContents = useCallback(() => {
        if (playerInfo) {
            return _jsx(PlayerInfoPanelContents, { playerInfo: playerInfo, isFriend: isFriend });
        }
        if (loadingUsername) {
            return null;
        }
        return _jsxs(PanelItem, { children: [isMobile ? 'Tap' : 'Click', " a player to view their info."] });
    }, [loadingUsername, playerInfo, isFriend]);
    return (_jsxs(PanelContainer, { padding: PANEL_FRAMELESS_CONTENT_PADDING_STRING, "aria-label": 'player info panel', children: [_jsx(PanelHeader, { title: getHeaderTitle(), withPadding: true, headerRight: playerInfo ? _jsx(PlayerInfoPanelButtonGroup, { playerInfo: playerInfo, isFriend: isFriend }) : undefined }), _jsx(FramelessPanelSection, { backgroundColor: PLAYER_INFO_PANEL_LIST_BACKGROUND_COLOR, children: getContents() })] }));
};
